.popover {
  &:focus {
    outline: none;
  }

  &.matchWidth {
    width: var(--radix-popover-trigger-width);
    max-height: var(--radix-popover-content-available-height);
  }
}
